import React, { useEffect, useState } from 'react'
import Config from '../Config';
import Cookies from 'js-cookie';
import { useAuthHandling } from '../useAuthhandling';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../Sidebar';
import Navbar from '../Navbar';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import moment from 'moment';


function Propertyview() {
    const location = useLocation();
    const levels=location.state.level
    const { isAuthorized, handleUnauthorized } = useAuthHandling();
    let navigate = useNavigate();
    let { id } = useParams();
    const tokens = Cookies.get("a_token");
    if (!tokens) {
        navigate("/");
    }
    const [banner, setBanner] = useState([]);
    const [enqtoggle, setEnqtoggle] = useState([]);

    const [toggle, setToggle] = useState(false);
    const [blocktoggle, setBlocktoggle] = useState(false);
    const [invitetoggle, setInvitetogg] = useState(false);
    const [projecttoggle, setProjecttogg] = useState(false);
    const [ratingtoggle, setRatingtogg] = useState(false);
    const [reporttoggle, setReporttogg] = useState(false);
    const [prof, setProf] = useState([]);



    const getinfo = async (e) => {
        let Url;
        if(levels==='sell'){
            Url='/api/v1/crm/property/get-property/';
        }
        else{
            Url='/api/v1/crm/rent/get-property/';

        }
        const res = await fetch(`${Config.apiurl}${Url}${id}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
        });
        if (res.status === 200) {
            const data = await res.json();
            setBanner(data.data);
        }
        else if (res.status === 401) {
            handleUnauthorized();
            getinfo();
        }
        else {
            console.log("error");
        }
    };

   

    useEffect(() => {
        getinfo();
    }, [])

    const formattedSoldOutDate = banner?.soldOutDate
    ? new Date(banner?.soldOutDate).toISOString().split('T')[0]
    : '';
    
    return (
        <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className='view_page_top'>
                            {levels==='rent'? 
                                <Link to="/property-list-rent">Property list</Link>
                                :
                                <Link to="/property-list">Property list</Link>
                            }
                            <Link to={"/edit-property/" + id} state={{
                                     
                                     level: levels,
                                   }} >Edit</Link>
                        </div>
                        <h4>{levels==='rent'? 'Property Rent':'Property Sell'}</h4>
                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Property View page</h4>

                                        <div className='row view_div_row'>
                                    <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Property Id </h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p> {banner?.propertyId}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Property Ad Title </h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p> {banner?.propertyAdTitle}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Property Name </h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p> {banner?.propertyName}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Contact Person</h6>
                                        </div>
                                        <div className='view_portion_p_1'>
                                            <p> {banner?.contactPerson?.name}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6> Descriptiom </h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.description}</p>
                                        </div>

                                    </div>
                                </div>

                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Property Type </h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            {banner?.propertyType?.propertyType}
                                        </div>

                                    </div>
                                </div>

                                {banner.yearOfConstruction?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Year of Construction</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.yearOfConstruction}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}

{banner.bedrooms?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Bed Rooms</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.bedrooms==='1_BHK'?'1 Bhk' :banner?.bedrooms==='2_BHK'?'2 Bhk':banner?.bedrooms==='3_BHK'?'3 Bhk':banner?.bedrooms==='4_BHK'?'4 Bhk':banner?.bedrooms==='4_PLUS_BHKBHK'?'5+ Bhk':""}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}

{banner.bathrooms?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Bathrooms</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.bathrooms}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.balcony?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Balcony</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.balcony}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.buildUpArea?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Build Up Area</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.buildUpArea}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.carpetArea?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Carpet Area</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.carpetArea}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.furnished?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Furnished</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.furnished}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.noOfFloors?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Number of Floors</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.noOfFloors}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.garage?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Garage</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.garage}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.roadWidth?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Road Width</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.roadWidth}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.plotArea?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Plot Area</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.plotArea}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.price?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Price</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.price}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.type?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Type</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.type}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.floorNumber?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Floor number</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.floorNumber}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.length?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Length</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.length}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.breadth?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Breadth</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.breadth}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.maintenanceCharge?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Maintenance Charges</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.maintenanceCharge}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 
 {banner.listedBy?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Listed By</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.listedBy}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}

 {banner.propertyLocation?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Property Location</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.propertyLocation}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.metaTitle?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Meta Title</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.metaTitle}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.canonicalURL?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Canonical URL</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.canonicalURL}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
                                 {banner.condition?
                                <div className='col-12 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Condition</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.condition}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.metaDescription?
                                <div className='col-12 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Meta Description</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.metaDescription}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 {banner.status?
                                <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Status</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {banner?.status}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
 

 {banner?.soldOut===true ?
                              <div className='col-6 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6'>
                                            <h6>Sold out date</h6>
                                        </div>
                                        <div className='view_portion_p'>
                                            <p>  {formattedSoldOutDate}</p>
                                        </div>

                                    </div>
                                </div>
                                :""}
                                {/* Aminities */}
                                {banner?.amenities?.length>0?
                                <div className='col-12 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6 view_portion_h6_togg' onClick={(e) => setBlocktoggle(!blocktoggle)}>
                                            <h6>  Aminities</h6>
                                            {blocktoggle ?
                                                <span><IoIosArrowUp /></span>
                                                :
                                                <span><IoIosArrowDown /></span>
                                            }
                                        </div>
                                        {blocktoggle ?
                                            banner.amenities.length > 0 ?
                                            <div className='property_aminity_all'>
                                                {banner.amenities.map((block, ind) => {
                                                    return (

                                                        <div className='property_aminity'>
                                                           
                                                                {block} { ","} { " "}

                                                           
                                                        </div>
                                                    )
                                                })}
                                                </div>
                                                :""
                                            : ""
                                        }
                                    </div>

                                </div>
                                :""}

{banner?.propertyImages ?
                                    <div className='col-12 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Image </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                {banner.propertyImages.map((img,i)=>{
                                return(
                                                <img src={img?.imageFile} style={{ width: "100px", height: "100px", marginTop: "10px", marginRight:"5px" }} />
                                )}
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                    : ""}
                              
                             
                               
                            </div>

                                        

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Propertyview
